import React from 'react';
import classNames from 'classnames';

import css from './style.module.scss';

import LoaderWrap from './LoaderWrap';
import PrimaryIconSvg from './PrimaryIconSvg';

const PageLoader = () => (
  <LoaderWrap>
    <div className={classNames(css.loader, css.loader_size_xl)}>
      <PrimaryIconSvg />
    </div>
  </LoaderWrap>
);

export default PageLoader;
